import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NoInternet.css';
import NoInternetImg from "../assets/img/nointernet.jpg";

const NoInternet = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
    const testUrl = 'https://appstore-api.roshtech.co.ke/api/health'

    useEffect(() => {
  const quickStatus = () => setIsOnline(navigator.onLine);

  const deepCheck = async () => {
    try {
      const res = await fetch(testUrl, { cache: "no-store" });
      setIsOnline(res.ok);
    } catch {
      setIsOnline(false);
    }
  };

  window.addEventListener("online", deepCheck);
  window.addEventListener("offline", quickStatus);

  // do one initial deep check
  deepCheck();

  // remove polling OR keep long interval
  const checkInterval = setInterval(deepCheck, 120000); // every 2 mins

  return () => {
    clearInterval(checkInterval);
    window.removeEventListener("online", deepCheck);
    window.removeEventListener("offline", quickStatus);
  };
}, []);


  /*useEffect(() => {
    let checkInterval;

    const quickStatus = () => {
      setIsOnline(navigator.onLine); // instant browser-reported status
    };

    const deepCheck = async () => {
      try {
        const response = await fetch(testUrl, { cache: "no-store" });
        setIsOnline(response.ok);
      } catch {
        setIsOnline(false);
      }
    };

    // Listen for OS-level network changes
    window.addEventListener("online", () => {
      quickStatus();
      deepCheck(); // confirm actual internet is back
    });

    window.addEventListener("offline", () => {
      quickStatus();
    });

    // Initial check
    deepCheck();

    // Re-check periodically to catch fake online states
    checkInterval = setInterval(deepCheck, 60000); // every 5 seconds

    return () => {
      clearInterval(checkInterval);
      window.removeEventListener("online", quickStatus);
      window.removeEventListener("offline", quickStatus);
    };
  }, []);*/

  if (isOnline) {
    return children;
  }

  return (
      <div className="container">
      <div className="message-wrapper">
        <h5 className="lead text text-danger">Oops, the internet went out.</h5>
        <img src={NoInternetImg} alt="No Internet Connection" />
        <p>What you are trying to do requires internet connection</p>
        <p id="network-status-text">
          Please check your internet connection{' '}
          <a href="/">And try again.</a>
         
        </p>
      </div>
    </div>
  );
};

export default NoInternet;
